const supportedLocales = process.env.SUPPORTED_LOCALES ? JSON.parse(process.env.SUPPORTED_LOCALES) : ['pl', 'en', 'de'];
const locales = !supportedLocales || supportedLocales.length === 0 ? ['pl', 'en', 'de'] : supportedLocales;
const defaultLocale = process.env.DEFAULT_LOCALE || 'pl';

const basePath = process.env.BASE_PATH || '';
const i18nProject = process.env.I18N_PROJECT || 'vox-pl';

const isLoopbackOrigin = (origin) => {
  try {
    const { hostname } = new URL(origin);
    return hostname === '127.0.0.1' || hostname === 'localhost' || hostname === '::1';
  } catch {
    return false;
  }
};

const internalOrigin =
  typeof window === 'undefined'
    ? (() => {
        const port = process.env.PORT || '8080';
        const fallback = `http://127.0.0.1:${port}`;
        const explicit = (process.env.I18N_INTERNAL_ORIGIN || '').trim().replace(/\/$/, '');
        return explicit && isLoopbackOrigin(explicit) ? explicit : fallback;
      })()
    : '';

const bffRelativeLoadPath = `${basePath}/api/i18n/{{lng}}/{{ns}}?project=${i18nProject}`;
const bffLoadPath = typeof window === 'undefined' ? `${internalOrigin}${bffRelativeLoadPath}` : bffRelativeLoadPath;

/** @type {import('next-i18next').UserConfig} */
const config = {
  i18n: {
    locales,
    defaultLocale,
    localeDetection: false,
  },
  // Fallback (build IS_BUILD, awaria BFF): next-i18next czyta z dysku
  localePath: typeof window === 'undefined' ? require('path').resolve('./public/locales') : '/locales',
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  partialBundledLanguages: true,
  serializeConfig: false,
};

const HttpBackend = require('i18next-http-backend/cjs');
config.use = [HttpBackend];
config.backend = {
  loadPath: bffLoadPath,
};

module.exports = config;
